import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { QuotationLine, QuotationLineCreate, QuotationLineFilter } from '../data/quotationLine';

export function createQuotationLineService(client: AxiosInstance) {
  return createCrudService<QuotationLine, QuotationLineCreate, QuotationLineFilter>(
    client,
    '/crm/QuotationLine',
    'id',
  );
}

export type QuotationLineService = CrudService<QuotationLine, QuotationLineCreate, QuotationLineFilter>;
